/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { KeyValue } from '@angular/common';
import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AllFilters, FieldType } from '../widget-dashboard-layout.model';

@Component({
	selector: 'app-widget-dashboard-layout',
	templateUrl: './widget-dashboard-layout.component.html',
	styleUrls: ['./widget-dashboard-layout.component.css'],
})
export class WidgetDashboardLayoutComponent implements OnInit, OnChanges {
	@Input() client: cs.IClientWithExpansionV3Dto;
	public uniqueref = '';
	/* eslint-disable @typescript-eslint/no-explicit-any */
	public windowsUrl: any;
	public window: any;
	public filters = [] as any;
	public category = 'clients';
	public data: any;
	public keys: any;
	public groups = [] as any;
	public additionalInfoObject = [] as any;
	public displayForm = false;
	public companyId = '';
	public clientEntityType = '';

	public onCompare(_left: KeyValue<any, any>, _right: KeyValue<any, any>): number {
		return 1;
	}

	constructor() {}

	public async ngOnInit(): Promise<void> {
		this.window = window;
	}

	async ngOnChanges() {
		if (this.client) {
			this.uniqueref = this.client.id;
			this.getJsonLayoutData();
		}
	}

	public getJsonLayoutData(): void {
		const queryUrl = '/api/custom-fields/v1/layout/' + this.category; // An actual api call
		fetch(queryUrl, {
			method: 'GET',
			headers: {
				Accept: 'text/plain',
			},
		})
			.then(async response => response.json())
			.then(async jsonBody => {
				await this.loadLayoutData(jsonBody);
			})
			.catch(error => {
				console.log(error);
				return 'an error occurred';
			});
	}

	public async loadLayoutData(
		jsonData: {
			id: string;
			category: string;
			companyId: string;
			filterRule: string;
			layoutJson: string;
		}[],
	): Promise<any> {
		if (!jsonData || jsonData.length === 0 || !jsonData[0] || !jsonData[0].layoutJson) {
			console.warn('Invalid or empty jsonData provided to loadLayoutData');
			return;
		}

		const realData = JSON.parse(jsonData[0].layoutJson);
		this.companyId = jsonData[0].companyId;
		this.groups = realData.data;
		if (this.groups && this.groups.length > 0) {
			this.displayForm = true;
		}

		await this.getJsonUserData();
	}

	public async getJsonUserData(): Promise<void> {
		const referenceId = this.uniqueref;
		const queryUrl = `/api/core/v3/companies/${
			this.companyId
		}/clients/${referenceId.toString()}?expand=primaryContactExpanded`;
		fetch(queryUrl, {
			headers: {
				method: 'GET',
				Accept: 'text/plain',
			},
		})
			.then(async response => response.json())
			.then(async responseBody => {
				this.clientEntityType = responseBody?.primaryContactExpanded?.entityType?.name;
				this.updateFilters(this.clientEntityType);
				await this.getJsonCustomFieldData();
			})
			.catch(error => {
				console.log(error);
				return 'an error occurred';
			});
	}

	/** Update the filters based on entityTypes */
	public updateFilters(entityType: string): void {
		switch (entityType) {
		case 'Individual':
			this.filters = [AllFilters.Clients, AllFilters.Individuals];
			break;
		case 'Unspecified':
			this.filters = [AllFilters.Businesses];
			break;
		default:
			this.filters = [AllFilters.Clients, AllFilters.Businesses];
			break;
		}
	}

	public async getJsonCustomFieldData(): Promise<any> {
		const referenceId = this.uniqueref;
		const queryUrl = `/api/custom-fields/v1/data/${referenceId.toString()}`; // An actual api call
		fetch(queryUrl, {
			headers: {
				method: 'GET',
				Accept: 'text/plain',
			},
		})
			.then(async response => response.json())
			.then(async jsonBody => this.loadUserData(jsonBody))
			.catch(error => {
				console.log(error);
				return 'an error occurred';
			});
	}

	public async loadUserData(
		jsonData: {
			id: string;
			filterRule: string;
			dataJson: string;
			layoutId: string;
		}[],
	): Promise<any> {
		if (jsonData.length > 0) {
			// This.currentDataId = jsonData[0].id;
			const userData = JSON.parse(jsonData[0].dataJson) as {
				[key: string]: string;
			};
			this.data = userData;
			this.keys = Object.keys(this.data);
			this.generateAdditionalInfoObject();
		} else {
			this.data = [];
			this.keys = [];
			this.generateAdditionalInfoObject();
		}

		return Promise.resolve();
	}

	public generateAdditionalInfoObject(): void {
		this.additionalInfoObject = [];
		this.groups.forEach((group: any) => {
			// If group in filters, display it.
			if (this.filters.includes(group.filter)) {
				const fields = this.generateGroup(group);
				if (fields.length) {
					this.additionalInfoObject.push({ [`${group.name}`]: fields });
				}
			}
		});
	}

	public generateGroup(group: any): any {
		const Group = [] as any;

		group.fields.forEach((field: any) => {
			if (this.data[`item${field.id}`] !== undefined &&
					this.data[`item${field.id}`] !== null &&
					this.data[`item${field.id}`] !== false &&
					this.data[`item${field.id}`].length !== 0) {
				this.keys.forEach((key: any) => {
					if (key === `item${field.id}`) {
						Group.push({
							[`${field.name}`]: `${this.setFieldFormat(field)}`,
						});
					}
				});
			}
		});

		return Group;
	}

	public setFieldFormat(field: any): string {
		let value = this.data[`item${field.id}`];
		if (field.type === FieldType.Date) {
			const inputDate = new Date(value);
			if (!isNaN(inputDate.getTime())) {
				// Brazilian format: dd-mm-yyyy
				value =
					('0' + inputDate.getUTCDate().toString()).toString().slice(-2) +
					'-' +
					('0' + (inputDate.getUTCMonth() + 1).toString()).toString().slice(-2) +
					'-' +
					inputDate.getUTCFullYear().toString();
			}
		}

		return value;
	}
}
